/**
 * API URL configuration for production and local.
 * - App/dashboard requests use REACT_APP_API_SERVER_URL (backend_app in split, or monolithic).
 *
 * SDK write host is controlled by the SDK itself (hardcoded base).
 */

export const getAppApiUrl = () => process.env.REACT_APP_API_SERVER_URL || '';

const CDN_SCRIPT_URL = 'https://cdn.cryptique.io/scripts/analytics/1.0.1/cryptique.script.min.js';

/**
 * Returns the Cryptique embed script snippet for a given siteId.
 */
export function getEmbedScriptSnippet(siteId) {
  return `<script>
  var script = document.createElement('script');
  script.src = '${CDN_SCRIPT_URL}';  
  script.setAttribute('site-id', '${(siteId || '').replace(/'/g, "\\'")}');
  script.setAttribute('auto-events', 'false');
  script.setAttribute('auto-events-disabled-paths', '');
  script.setAttribute('auto-events-disabled-events', '');
  document.head.appendChild(script);
</script>`;
}
